import axios from 'axios'
import {
	Message
} from 'element-ui' // 引入Element UI的消息提示组件

// 创建axios实例
const request = axios.create({
	// 从运行时配置读取接口地址（public/config.js 中修改，打包后可直接改）
	baseURL: (typeof window !== 'undefined' && window.APP_CONFIG) ? window.APP_CONFIG.BASE_URL : '/dev-api',
	timeout: 10000 // 请求超时时间
})

// 添加重试配置
request.defaults.retry = 3 // 重试次数
request.defaults.retryDelay = 1000 // 重试延迟时间

// 请求拦截器
request.interceptors.request.use(
	config => {
		// 在发送请求之前做些什么
		// 例如在请求头中加token
		// const token = store.getters.token
		// if (token) {
		//   config.headers['Authorization'] = 'Bearer ' + token
		// }
		return config
	},
	error => {
		// 对请求错误做些什么
		console.log('请求错误:', error) // for debug
		Message({
			message: '请求发送失败，请检查网络连接',
			type: 'error',
			duration: 5000
		})
		return Promise.reject(error)
	}
)

// 响应拦截器
request.interceptors.response.use(
	response => {
		const res = response.data

		// 如果自定义代码不是200，则判断为错误
		if (res.code !== 200) {
			// 优先使用 msg 字段，其次 message 字段
			const errorMsg = res.msg || res.message || '请求失败'
			console.error('响应错误:', errorMsg)
			console.error('完整响应:', res)

			// 对于500错误，显示更详细的提示
			let displayMsg = errorMsg
			if (res.code === 500) {
				// 如果是数据库错误，提取关键信息
				if (errorMsg.includes('Unknown column')) {
					const match = errorMsg.match(/Unknown column '(\w+)'/)
					if (match) {
						displayMsg = `数据库字段缺失: ${match[1]}，请联系管理员`
					} else {
						displayMsg = '数据库查询异常，请联系管理员'
					}
				} else if (errorMsg.includes('Error querying database')) {
					displayMsg = '数据库查询失败，请联系管理员'
				} else {
					displayMsg = '服务器内部错误，请稍后重试'
				}
			}

			Message({
				message: displayMsg,
				type: 'error',
				duration: 5000
			})

			// 50008: 非法的token; 50012: 其他客户端登录了; 50014: Token 过期了;
			if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
				// 重新登录
				console.log('需要重新登录')
			}
			return Promise.reject(new Error(displayMsg))
		} else {
			return res
		}
	},
	error => {
		// 处理网络错误和超时
		if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
			Message({
				message: '请求超时，请稍后重试',
				type: 'error',
				duration: 5000
			})
		} else if (!error.response) {
			// 网络错误
			Message({
				message: '网络连接异常，请检查网络设置',
				type: 'error',
				duration: 5000
			})
		} else {
			// 其他错误
			const status = error.response.status
			let errorMsg = '请求失败'

			switch (status) {
				case 400:
					errorMsg = '请求参数错误'
					break
				case 401:
					errorMsg = '未授权，请重新登录'
					break
				case 403:
					errorMsg = '拒绝访问'
					break
				case 404:
					errorMsg = '请求资源不存在'
					break
				case 408:
					errorMsg = '请求超时'
					break
				case 500:
					errorMsg = '服务器内部错误'
					break
				case 501:
					errorMsg = '服务未实现'
					break
				case 502:
					errorMsg = '网关错误'
					break
				case 503:
					errorMsg = '服务不可用'
					break
				case 504:
					errorMsg = '网关超时'
					break
				case 505:
					errorMsg = 'HTTP版本不受支持'
					break
				default:
					errorMsg = `连接错误${status}`
			}

			Message({
				message: errorMsg,
				type: 'error',
				duration: 5000
			})
		}

		// 添加重试机制
		const config = error.config;

		// 如果配置不存在或未设置重试选项，则拒绝错误
		if (!config || !config.retry) return Promise.reject(error);

		// 设置变量跟踪重试次数
		config.__retryCount = config.__retryCount || 0;

		// 检查是否超过总重试次数
		if (config.__retryCount >= config.retry) {
			console.log('请求失败，已达到最大重试次数:', error) // for debug
			return Promise.reject(error);
		}

		// 增加重试次数
		config.__retryCount += 1;

		// 创建新的Promise来处理指数后退
		const delay = new Promise(resolve => {
			setTimeout(() => resolve(), config.retryDelay || 1000);
		});

		// 返回Promise，在延迟后重新尝试请求
		return delay.then(() => request(config));
	}
)

export default request